module.exports = __webpack_public_path__ + "img/7minutos6.496a4cc8.jpg";